import React from "react";
import { CommunityFeedType } from "../../types";
import SingleComent from "./singleComent";
type CommentListProp = {
  communityFeed: CommunityFeedType | undefined;
  refetch?: () => void;
  loadData?: boolean;
};

const CommentList: React.FC<CommentListProp> = ({
  communityFeed,
  refetch,
  loadData,
}) => {
  const communityFeedComments = communityFeed?.comments;
  //  console.log(communityFeedComments);

  return (
    <>
      <div className="flex flex-col w-full">
        {communityFeedComments?.map((comment) => (
          <SingleComent
            key={comment.id}
            commentFeed={comment}
            refetch={refetch}
            communityFeed={communityFeed}
            loadData={loadData}
          />
        ))}
      </div>
    </>
  );
};

export default CommentList;
